export const subscriptionKeys = {
  all: ['subscription'] as const,
  status: (userId: string | null) => ['subscription', userId ?? 'anonymous', 'status'] as const,
}
